import React from 'react';
import propTypes from 'prop-types';

InfoItem.propTypes = {
  onClick: propTypes.func.isRequired,
  title: propTypes.string.isRequired,
  content: propTypes.string.isRequired,
  allowUpdate: propTypes.bool,
};

export default function InfoItem(props) {
  let { onClick, title, content, allowUpdate} = props;
  return(
    <div className="custom-poi-item" onClick={onClick}>
      <span>{title}</span>
      <p>{content}</p>
      { allowUpdate && <div className="tips"><i className="icon icon-edit"></i></div>}
    </div>
  );
}


// WEBPACK FOOTER //
// ./src/components/CustomPoi/InfoItem.js